/**
 * Keybinds Tab - Coming Soon
 * Will show default keybinds with custom keybind editor in the future
 */
export default function KeybindsTab() {
  const defaultKeybinds = [
    { action: 'Toggle Mute', keybind: 'Ctrl+Shift+M' },
    { action: 'Toggle Deafen', keybind: 'Ctrl+Shift+D' },
    { action: 'Push to Talk', keybind: 'Ctrl+Space' },
    { action: 'Open Settings', keybind: 'Ctrl+,' },
    { action: 'Search', keybind: 'Ctrl+K' },
  ]

  return (
    <div className="p-6 max-w-4xl">
      <h3 className="text-xl font-semibold text-white mb-6">Keybinds</h3>

      <div className="mb-4 p-3 bg-[#00ad9f]/10 border border-[#00ad9f]/30 rounded-lg">
        <p className="text-sm text-[#94a3b8]">
          🎹 Custom keybind editor coming soon! Below are the default keybinds.
        </p>
      </div>

      <div className="space-y-2">
        {defaultKeybinds.map((kb, index) => (
          <div
            key={index}
            className="flex items-center justify-between p-3 bg-[#0a1628] rounded hover:bg-[#1e3a5f] transition-colors"
          >
            <span className="text-sm text-[#ffffff]">{kb.action}</span>
            <kbd className="px-3 py-1.5 bg-[#0f172a] border border-[#1e3a5f] rounded text-xs text-[#94a3b8] font-mono">
              {kb.keybind}
            </kbd>
          </div>
        ))}
      </div>
    </div>
  )
}
